import { useMemo, useRef, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { useChildComponent } from '@gogame/hooks-ts';

import useScreenGo from './Screen/useScreenGo';

export const useChildComponentRouteV2 = (
  initComponent,
  initProps,
  { idKey = 'id' } = {}
) => {
  const params = useParams();
  const location = useLocation();
  const go = useScreenGo();

  const childComponentProps = useMemo(() => {
    return {
      ...initProps,
      onExited: () => {
        if (prevIdRef.current === params[idKey]) {
          go('..');
        }
      },
      ...params,
      ...location.state,
      // ?? need to discuss with team and server team
      id: Number(params[idKey]) || params[idKey],
      // id: Number(params[idKey])
    };
  }, [params, location.state]);

  const [component, setChildComponent] = useChildComponent(
    initComponent,
    childComponentProps
  );

  const prevIdRef = useRef(params[idKey]);

  //Save previous url id for onExited don't go('..')
  useEffect(() => {
    if (params[idKey] !== prevIdRef.current) {
      prevIdRef.current = params[idKey];
    }
  }, [params[idKey]]);

  useMemo(() => {
    if (component && params[idKey] !== prevIdRef.current) {
      setChildComponent(initComponent, childComponentProps);
    }
  }, [initComponent, setChildComponent, childComponentProps, params[idKey]]);

  return component;
};
